import { useCallback, useRef, useEffect } from 'react';

export const useThrottle = <T extends (...args: any[]) => void>(
  callback: T,
  delay = 1000, //(ms)
): T => {
  const lastCallRef = useRef(0);
  const timeoutRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = undefined;
      }
    };
  }, []);

  return useCallback(
    (...args: Parameters<T>) => {
      const now = Date.now();
      const remaining = delay - (now - lastCallRef.current);

      if (remaining <= 0) {
        lastCallRef.current = now;
        callback(...args);
      } else {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
          lastCallRef.current = now;
          callback(...args);
        }, remaining);
      }
    },
    [callback, delay],
  ) as T;
};
